import { render, staticRenderFns } from "./ToastMessageEx.vue?vue&type=template&id=63851eae&"
import script from "./ToastMessageEx.vue?vue&type=script&lang=js&"
export * from "./ToastMessageEx.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.10.0_css-loader@3.2.0_lodash@4.17.21_vue-template-compiler@2.7.15_webpack@4.46.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports